<template>
  <div class="insurance-information-page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>投保信息管理</span>
      </div>

      <div class="toolbar">
        <el-form :inline="true" size="small">
          <el-form-item label="自定义检索">
            <el-input
              v-model.trim="keywordName"
              clearable
              maxlength="100"
              placeholder="请输入公司名称"
              style="width: 240px"
              @keyup.enter.native="search"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="showAll">
              全部
            </el-button>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openForm('add')"
        >
          新增
        </el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="rows"
        border
        stripe
        height="calc(100vh - 275px)"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="公司名称"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column prop="province" label="省份" width="130" />
        <el-table-column prop="city" label="城市" width="110" />
        <el-table-column
          prop="license_no"
          label="营业执照编号"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="tax_mobile"
          label="税务登记联系电话"
          width="150"
        />
        <el-table-column
          prop="tax_bank"
          label="税务开户银行名称"
          width="190"
          show-overflow-tooltip
        />
        <el-table-column
          prop="tax_bank_no"
          label="税务开户银行账号"
          width="190"
          show-overflow-tooltip
        />
        <el-table-column
          prop="tax_address"
          label="税务登记地址"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          width="165"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="updated_at"
          label="更新时间"
          width="165"
          :formatter="dateFormatter"
        />
        <el-table-column label="校验状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="isChecked(scope.row.checked) ? 'success' : 'info'">
              {{ isChecked(scope.row.checked) ? "已校验" : "未校验" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="openForm('view', scope.row)"
            >
              查看
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="openForm('edit', scope.row)"
            >
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        :current-page="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[5, 10, 15, 20]"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize"
        @current-change="changePage"
      />
    </el-card>

    <insurance-information-form
      :visible.sync="formVisible"
      :mode="formMode"
      :company-id="currentCompanyId"
      @saved="fetchList"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { getCompanyList } from "@/api/company";
import InsuranceInformationForm from "./components/InsuranceInformationForm.vue";

export default {
  name: "InsuranceInformationManagement",
  components: { InsuranceInformationForm },
  data() {
    return {
      loading: false,
      rows: [],
      keywordName: "",
      queryName: "",
      pagination: {
        page: 1,
        rows: 15,
        total: 0
      },
      formVisible: false,
      formMode: "add",
      currentCompanyId: ""
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const params = {
          page: this.pagination.page,
          rows: this.pagination.rows
        };
        if (this.queryName) params.name = this.queryName;
        const res = await getCompanyList(params);
        this.rows = res.rows || res.data || [];
        this.pagination.total = Number(res.total || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.queryName = this.keywordName;
      this.pagination.page = 1;
      this.fetchList();
    },
    showAll() {
      this.keywordName = "";
      this.queryName = "";
      this.pagination.page = 1;
      this.fetchList();
    },
    openForm(mode, row) {
      this.formMode = mode;
      this.currentCompanyId = row ? row.id : "";
      this.formVisible = true;
    },
    changeSize(value) {
      this.pagination.rows = value;
      this.pagination.page = 1;
      this.fetchList();
    },
    changePage(value) {
      this.pagination.page = value;
      this.fetchList();
    },
    isChecked(value) {
      return value === true || String(value) === "true" || Number(value) === 1;
    },
    dateFormatter(row, column, value) {
      if (!value || value === "0001-01-01T00:00:00Z") return "";
      const timestamp = /^\d{10}$/.test(String(value))
        ? Number(value) * 1000
        : value;
      const date = dayjs(timestamp);
      return date.isValid() && date.year() !== 1
        ? date.format("YYYY-MM-DD HH:mm:ss")
        : "";
    }
  }
};
</script>

<style scoped>
.insurance-information-page {
  padding: 20px;
}
.card-header {
  font-size: 16px;
  font-weight: 500;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
